import { render, staticRenderFns } from "./section-info-col-type.vue?vue&type=template&id=52f92b5e&scoped=true&"
import script from "./section-info-col-type.ts?vue&type=script&lang=ts&"
export * from "./section-info-col-type.ts?vue&type=script&lang=ts&"
import style0 from "./section-info-col-type.scss?vue&type=style&index=0&id=52f92b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f92b5e",
  null
  
)

export default component.exports